export const VisibilityToggleIcon = ({ hidden, textColor }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke={textColor || "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {hidden ? (
            <>
                {/* Base checklist shape */}
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="2" />
                {/* Strikethrough line */}
                <line x1="4" y1="4" x2="20" y2="20" />
            </>
        ) : (
            <>
                {/* Base checklist shape */}
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="2" />
                {/* Visible checkmark */}
                <path d="M9 12l2 2 4-4" />
            </>
        )}
    </svg>
);